import moment from 'moment';
import { IJob, IJobData, ITabIndex } from '../EditJob/types';
import { SortableColumnId } from '../Job/types';
import { convertToGroupAndTabIndex, convertToPanelIndex, TabGroup } from '../EditJob/tabIndexUtils';

export const jobsConfig = {
  sortableColumnsDefaults: [
    {
      id: 'reference',
      label: 'Reference',
      sortable: false,
      canToggle: false,
      enabled: true
    },
    {
      id: 'title',
      label: 'Title',
      sortable: true,
      canToggle: false,
      enabled: true
    },
    {
      id: 'published_at',
      label: 'Published',
      sortable: true,
      canToggle: true,
      enabled: false
    },
    {
      id: 'created_at',
      label: 'Created',
      sortable: true,
      canToggle: true,
      enabled: true
    },
    {
      id: 'expires_at',
      label: 'Expiry',
      sortable: true,
      canToggle: true,
      enabled: false
    },
    {
      id: 'applications_count',
      label: 'Applications',
      sortable: true,
      canToggle: true,
      enabled: true
    },
    {
      id: 'state',
      label: 'State',
      sortable: true,
      canToggle: true,
      enabled: true
    },
    {
      id: 'status',
      label: 'Status',
      sortable: true,
      canToggle: true,
      enabled: true
    },
    {
      id: 'entity',
      label: 'Entity',
      sortable: true,
      canToggle: true,
      enabled: true
    },
    {
      id: 'location',
      label: 'Location',
      sortable: false,
      canToggle: true,
      enabled: false
    },
    {
      id: 'assigned_user',
      label: 'Assigned User',
      sortable: false,
      canToggle: true,
      enabled: false
    },
    {
      id: 'recruitment_ad_user',
      label: 'RM User',
      sortable: false,
      canToggle: true,
      enabled: false
    },
    {
      id: SortableColumnId.NOTES,
      label: 'Notes',
      sortable: false,
      canToggle: true,
      enabled: false
    },
    {
      id: 'brand',
      label: 'Brand',
      sortable: false,
      canToggle: true,
      enabled: false
    }
  ],
  headers: [
    {
      name: 'reference',
      label: 'Reference'
    },
    {
      name: 'title',
      label: 'Title'
    },
    {
      name: 'published_at',
      label: 'Published'
    },
    {
      name: 'created_at',
      label: 'Created'
    },
    {
      name: 'expires_at',
      label: 'Expiry'
    },
    {
      name: 'applications_count',
      label: 'Applications'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'status',
      label: 'Status'
    },
    {
      name: 'entity',
      label: 'Entity'
    },
    {
      name: 'location',
      label: 'Location'
    },
    {
      name: 'assigned_user',
      label: 'Assigned User'
    },
    {
      name: 'recruitment_ad_user',
      label: 'RM User'
    },
    {
      name: 'notes',
      label: 'Notes'
    }
  ],
  archivedHeaders: [
    {
      name: 'reference',
      label: 'Reference'
    },
    {
      name: 'title',
      label: 'Title'
    },
    {
      name: 'published_at',
      label: 'Published'
    },
    {
      name: 'created_at',
      label: 'Created'
    },
    {
      name: 'expires_at',
      label: 'Expiry'
    },
    {
      name: 'applications_count',
      label: 'Applications'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'entity',
      label: 'Entity'
    },
    {
      name: 'location',
      label: 'Location'
    },
    {
      name: 'assigned_user',
      label: 'Assigned User'
    },
    {
      name: 'recruitment_ad_user',
      label: 'RM User'
    }
  ],
  dropdownOptions: [
    {
      name: 'published_at',
      label: 'Published'
    },
    {
      name: 'created_at',
      label: 'Created'
    },
    {
      name: 'expires_at',
      label: 'Expiry'
    },
    {
      name: 'applications_count',
      label: 'Applications'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'status',
      label: 'Status'
    },
    {
      name: 'entity',
      label: 'Entity'
    },
    {
      name: 'location',
      label: 'Location'
    },
    {
      name: 'assigned_user',
      label: 'Assigned User'
    },
    {
      name: 'recruitment_ad_user',
      label: 'RM User'
    },
    {
      name: 'notes',
      label: 'Notes'
    }
  ],
  archivedDropdownOptions: [
    {
      name: 'published_at',
      label: 'Published'
    },
    {
      name: 'created_at',
      label: 'Created'
    },
    {
      name: 'expires_at',
      label: 'Expiry'
    },
    {
      name: 'applications_count',
      label: 'Applications'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'entity',
      label: 'Entity'
    },
    {
      name: 'location',
      label: 'Location'
    },
    {
      name: 'assigned_user',
      label: 'Assigned User'
    },
    {
      name: 'recruitment_ad_user',
      label: 'RM User'
    }
  ],
  fieldDropdownSetting: {
    published_at: true,
    created_at: false,
    expires_at: true,
    applications_count: true,
    state: true,
    status: false,
    location: true,
    entity: true,
    assigned_user: false,
    recruitment_ad_user: false,
    notes: false
  },
  defaultFilterOptions: {
    state: [
      {
        value: 'published',
        name: 'Published'
      },
      {
        value: 'unpublished',
        name: 'Unpublished'
      },
      {
        value: 'draft',
        name: 'Draft'
      },
      {
        value: 'saved',
        name: 'Saved'
      },
      {
        value: 'closed',
        name: 'Closed'
      }
    ],
    entity: [
      {
        id: 1,
        name: 'No Entities Found'
      }
    ],
    status: [
      {
        name: 'No Statuses Found'
      }
    ],
    location: [
      {
        name: 'No Locations Found'
      }
    ],
    assigned_user: [
      {
        id: 1,
        name: 'No Assigned Users Found'
      }
    ],
    recruitment_ad_user: [
      {
        id: 0,
        name: 'No RM Users Found'
      }
    ]
  },
  currentStateOptions: {
    state: [
      {
        value: 'published',
        name: 'Published'
      },
      {
        value: 'unpublished',
        name: 'Unpublished'
      },
      {
        value: 'draft',
        name: 'Draft'
      },
      {
        value: 'saved',
        name: 'Saved'
      },
      {
        value: 'closed',
        name: 'Closed'
      }
    ]
  },
  archivedStateOptions: {
    state: [
      {
        value: 'saved',
        name: 'Saved'
      },
      {
        value: 'closed',
        name: 'Closed'
      }
    ]
  }
};

export const applicantDetailsDefault = {
  firstName: { error: '', required: true, value: '' },
  lastName: { error: '', required: true, value: '' },
  email: { error: '', required: true, value: '' },
  phone: { error: '', required: true, value: '' },
  addressFirstLine: { error: '', required: true, value: '' },
  addressSecondLine: { error: '', required: false, value: '' },
  country: { error: '', required: true, value: '' },
  region: { error: '', required: true, value: '' },
  employeeId: { error: '', required: false, value: '' }
};

export const createJobDefault = {
  reference: { error: '', required: true, value: '' },
  title: { error: '', required: true, value: '' },
  expires_at: { error: '', required: true, value: null },
  location: { error: '', required: true, value: '' }
};

export const editGeneralJobDefault = (job: IJob) => {
  return {
    reference: { error: '', required: true, value: job.reference },
    title: { error: '', required: true, value: job.title },
    expires_at: { error: '', required: true, value: job.expires_at },
    expiration_in_days: { error: '', required: false, value: job.expiration_in_days },
    time: { error: '', required: true, value: job.expires_at },
    location: { error: '', required: true, value: job.location },
    employment_status: { error: '', required: false, value: job.employment_status },
    salary_info: { error: '', required: false, value: job.salary_info },
    number_of_vacancies: {
      error: '',
      required: false,
      value: job?.number_of_vacancies ? job.number_of_vacancies : null
    },
    from_email: { error: '', required: false, value: job?.from_email ? job.from_email : '' },
    external_approval_id: {
      error: '',
      required: false,
      value: job?.external_approval_id ? job.external_approval_id : ''
    },
    requisitions: { error: '', required: false, value: job?.requisitions ? job.requisitions : [] },
    time_zone: { error: '', required: false, value: job?.time_zone ? job.time_zone : null },
    brand: { error: '', required: false, value: job?.brand ? job.brand : null },
    locale: { error: '', required: false, value: job?.locale ? localDefaults(job) : [] },
    country_id: { error: '', required: false, value: job?.country_id ? job?.country_id : null },
    options: job?.options ? additionalOptionsDefaults(job) : null,
    classification_list: job?.classifications?.length > 0 ? job.classifications : [],
    classification_ids: job?.classifications?.length > 0 ? setClassificationIds(job) : [],
    classifications: { error: '', required: false, value: null },
    sub_classifications: { error: '', required: false, value: null },
    auto_rater: { error: '', required: false, value: job?.auto_rater ? job.auto_rater : null },
    assigned_user: {
      error: '',
      required: false,
      value: job?.assigned_user ? job.assigned_user : null
    },
    smart_form_recipients: {
      error: '',
      required: false,
      value: job?.smart_form_recipients ? job.smart_form_recipients : []
    },
    pinned_users: { error: '', required: false, value: job?.pinned_users ? job.pinned_users : [] },
    recipients: { error: '', required: false, value: job?.recipients ? job.recipients : [] },
    salesperson: {
      error: '',
      required: false,
      value: job?.salesperson
        ? `${job.salesperson.id} - ${job.salesperson.firstname} ${job.salesperson.lastname}`
        : null
    },
    rm_team_member: {
      error: '',
      required: false,
      value: job?.rm_team_member
        ? `${job.rm_team_member.id} - ${job.rm_team_member.firstname} ${job.rm_team_member.lastname}`
        : null
    },
    external: job.external,
    internal: job.internal,
    privacy_acknowledgement: job.privacy_acknowledgement,
    entity_privacy_acknowledgement: job.entity_privacy_acknowledgement,
    entity_privacy_acknowledgement_link: job.entity_privacy_acknowledgement_link,
    linkedin_listing_opt_in: job.linkedin_listing_opt_in,
    address_state: {
      error: '',
      required: false,
      value: job?.address_state ? job?.address_state : ''
    },
    postcode: { error: '', required: false, value: job?.postcode ? job?.postcode : '' },
    tag_list: { error: '', required: false, value: job?.tag_list ? job?.tag_list : '' }
  };
};

export const editPanelWorkflowDefault = (job: IJob) => {
  return {
    panel_chairs: { error: '', required: false, value: job?.panel_chairs ? job.panel_chairs : [] },
    panel_members: {
      error: '',
      required: false,
      value: job?.panel_members ? job.panel_members : []
    },
    panel_observers: {
      error: '',
      required: false,
      value: job?.panel_observers ? job.panel_observers : []
    }
  };
};

export const editGoogleScriptDefault = (job: IJob) => {
  return {
    google_conversion_script: {
      error: '',
      required: false,
      value: job?.google_conversion_script ? job.google_conversion_script : ''
    }
  };
};

export const editRevolveDefault = (job: IJob) => {
  return {
    revolve_position_title: {
      error: '',
      required: false,
      value: job?.revolve_position_title ? job.revolve_position_title : ''
    }
  };
};

export const editRequisitionInfoDefault = (job: IJob) => {
  return {
    requisition_info: {
      error: '',
      required: false,
      value: job?.requisition_info ? job.requisition_info : ''
    }
  };
};

export const editDescriptionDefault = (job: IJob) => {
  return {
    summary: { error: '', required: false, value: job?.summary ? job.summary : '' },
    description: { error: '', required: false, value: job?.description ? job.description : '' }
  };
};

export const editTemplateDefault = (job: IJob) => {
  return {
    template_enabled: job?.template_enabled,
    template: { error: '', required: false, value: job?.template ? job.template : '' }
  };
};

export const editSourcesDefault = (job: IJob) => {
  return {
    sources: { error: '', required: false, value: job?.sources ? job.sources : [] }
  };
};

export const editAttachmentsDefault = (job: IJob) => {
  return {
    candidate_attachments: {
      error: '',
      required: false,
      value: job?.candidate_attachments ? job.candidate_attachments : []
    }
  };
};

export const newJobsConfig = {
  resource_field_choices: [
    {
      id: 'resources[description]',
      name: 'Description',
      position: 0
    },
    {
      id: 'resources[questions]',
      name: 'Questions',
      position: 1
    },
    {
      id: 'resources[attachments]',
      name: 'Attachments',
      position: 2
    },
    {
      id: 'resources[sources]',
      name: 'Sources',
      position: 3
    },
    {
      id: 'resources[auto_actions]',
      name: 'Auto-Actions',
      position: 4
    },
    {
      id: 'resources[options]',
      name: 'Options',
      position: 5
    },
    {
      id: 'resources[visibility]',
      name: 'Visibility',
      position: 6
    }
  ]
};

export const resourceDefault = {
  'resources[description]': true,
  'resources[questions]': true,
  'resources[attachments]': true,
  'resources[sources]': true,
  'resources[auto_actions]': true,
  'resources[options]': true,
  'resources[visibility]': true
};

export const additionalOptionsDefaults = (job: IJob) => {
  return {
    ...job.options,
    indeed_apply: job.options.indeed_apply === '1',
    indeed_salary: job.options.indeed_salary === '1',
    sponsor_on_indeed: job.options.sponsor_on_indeed === '1',
    blind_rating: job.options.blind_rating === '1',
    hide_rating_activity: job.options.hide_rating_activity === '1',
    auto_ratings: job.options.auto_ratings === '1',
    title_field: job.options.title_field === '1',
    gender_field: job.options.gender_field === '1',
    employee_id_field: job.options.employee_id_field === '1',
    linkedin_field: job.options.linkedin_field === '1',
    linkedin_listing_opt_in: job.linkedin_listing_opt_in,
    job_expiry_email_reminder: job.options.job_expiry_email_reminder === '1'
  };
};

export const changeURL = (newValue: number, search: boolean, urlParams: string) => {
  if (search) {
    const tabIndex: ITabIndex = convertToGroupAndTabIndex(newValue);
    switch (tabIndex.group) {
      case TabGroup.JOB_INFORMATION:
        switch (tabIndex.index) {
          case 0:
            return '';
          case 1:
            return '?description';
          case 2:
            return '?template';
          case 3:
            return '?questions';
          case 4:
            return '?sources';
        }
        break;
      case TabGroup.CANDIDATE_SETTINGS:
        switch (tabIndex.index) {
          case 0:
            return '?attachments';
        }
        break;
      case TabGroup.AUTOMATION:
        switch (tabIndex.index) {
          case 0:
            return '?auto-statuses';
          case 1:
            return '?status-transitions';
          case 2:
            return '?auto-forward';
          case 3:
            return '?auto-email-reply';
          case 4:
            return '?auto-sms-reply';
          case 5:
            return '?auto-sms-forward';
        }
        break;
      case TabGroup.ADVANCED:
        switch (tabIndex.index) {
          case 0:
            return '?requisition-info';
          case 1:
            return '?configure-application-hr-questions';
          case 2:
            return '?automated-testgrid';
          case 3:
            return '?revolve';
          case 4:
            return '?google-conversion-script';
          case 5:
            return '?panel-workflow';
          case 6:
            return '?ai-studio';
        }
        break;
      case TabGroup.NEW_FEATURES:
        switch (tabIndex.index) {
          case 0:
            return '?auto-tags';
        }
        break;
      default:
        return '';
    }
  } else {
    switch (urlParams) {
      case '?description':
        return convertToPanelIndex(1, TabGroup.JOB_INFORMATION);
      case '?template':
        return convertToPanelIndex(2, TabGroup.JOB_INFORMATION);
      case '?questions':
        return convertToPanelIndex(3, TabGroup.JOB_INFORMATION);
      case '?sources':
        return convertToPanelIndex(4, TabGroup.JOB_INFORMATION);
      case '?attachments':
        return convertToPanelIndex(0, TabGroup.CANDIDATE_SETTINGS);
      case '?auto-statuses':
        return convertToPanelIndex(0, TabGroup.AUTOMATION);
      case '?status-transitions':
        return convertToPanelIndex(1, TabGroup.AUTOMATION);
      case '?auto-forward':
        return convertToPanelIndex(2, TabGroup.AUTOMATION);
      case '?auto-email-reply':
        return convertToPanelIndex(3, TabGroup.AUTOMATION);
      case '?auto-sms-reply':
        return convertToPanelIndex(4, TabGroup.AUTOMATION);
      case '?auto-sms-forward':
        return convertToPanelIndex(5, TabGroup.AUTOMATION);
      case '?requisition-info':
        return convertToPanelIndex(0, TabGroup.ADVANCED);
      case '?configure-application-hr-questions':
        return convertToPanelIndex(1, TabGroup.ADVANCED);
      case '?automated-testgrid':
        return convertToPanelIndex(2, TabGroup.ADVANCED);
      case '?revolve':
        return convertToPanelIndex(3, TabGroup.ADVANCED);
      case '?google-conversion-script':
        return convertToPanelIndex(4, TabGroup.ADVANCED);
      case '?panel-workflow':
        return convertToPanelIndex(5, TabGroup.ADVANCED);
      case '?ai-studio':
        return convertToPanelIndex(6, TabGroup.ADVANCED);
      case '?auto-tags':
        return convertToPanelIndex(0, TabGroup.NEW_FEATURES);
      default:
        return 1;
    }
  }
};

export const editJobObject = (
  candidateAttachments: IJobData,
  generalTabJobData: IJobData,
  descriptionTabJobData: IJobData,
  templateTabJobData: IJobData,
  revolveTabJobData: IJobData,
  googleScriptTabJobData: IJobData,
  panelWorkflowTabJobData: IJobData,
  sourceListIds: string[] | [],
  autoTagsTabJobData: IJobData
) => {
  const attachmentObject = {};
  candidateAttachments?.map((attachment) => {
    attachmentObject[attachment.id] = {
      name: attachment.label,
      mandatory: attachment.required ? '1' : '0'
    };
  });
  const expiryDate = generalTabJobData?.expires_at?.value;
  const newDateUTC = moment(expiryDate).utc().format('YYYY-MM-DD');
  const newTimeUTC = moment(expiryDate).utc().format('HH:mm');
  const updatedExpiryDate = `${newDateUTC}T${newTimeUTC}:00Z`;

  return {
    reference: generalTabJobData?.reference?.value,
    title: generalTabJobData?.title?.value,
    expires_at: updatedExpiryDate,
    expiration_in_days: generalTabJobData?.expiration_in_days?.value,
    location: generalTabJobData?.location?.value,
    external_requisition_id: generalTabJobData?.external_approval_id?.value
      ? generalTabJobData.external_approval_id.value
      : null,
    salesperson_id: generalTabJobData?.salesperson?.value
      ? generalTabJobData.salesperson.value.split(' -')[0]
      : null,
    // "recruitment_ad_user_id": 42,
    assigned_user_id: generalTabJobData?.assigned_user?.value
      ? generalTabJobData.assigned_user.value.id
      : null,
    pinned_users_ids: generalTabJobData?.pinned_users?.value
      ? generalTabJobData?.pinned_users?.value?.length > 0
        ? generalTabJobData?.pinned_users?.value?.map((x) => x.id)
        : []
      : [],
    recipient_ids: generalTabJobData?.recipients?.value
      ? generalTabJobData?.recipients?.value?.length > 0
        ? generalTabJobData?.recipients?.value?.map((x) => x.id)
        : []
      : [],
    time_zone: generalTabJobData?.time_zone?.value,
    locale: generalTabJobData?.locale?.value?.label
      ? generalTabJobData.locale.value?.value
      : generalTabJobData?.locale?.value,
    country_id: generalTabJobData?.country_id?.value
      ? generalTabJobData?.country_id?.value?.id
      : generalTabJobData?.country_id?.value,
    from_email: generalTabJobData?.from_email?.value,
    employment_status: generalTabJobData?.employment_status?.value,
    number_of_vacancies: generalTabJobData?.number_of_vacancies?.value,
    postcode: generalTabJobData?.postcode?.value,
    address_state: generalTabJobData?.address_state?.value,
    brand_id: generalTabJobData?.brand?.value ? generalTabJobData.brand.value.id : null,
    tag_list: generalTabJobData?.tag_list?.value,
    auto_rater_id: generalTabJobData?.auto_rater?.value?.id,
    salary_info: generalTabJobData?.salary_info?.value,
    requisition_ids: generalTabJobData?.requisitions?.value
      ? generalTabJobData?.requisitions?.value?.length > 0
        ? generalTabJobData?.requisitions?.value?.map((x) => x.id)
        : []
      : [],
    smart_form_recipients_ids: generalTabJobData?.smart_form_recipients?.value
      ? generalTabJobData?.smart_form_recipients?.value?.length > 0
        ? generalTabJobData?.smart_form_recipients?.value?.map((x) => x.id)
        : []
      : [],
    options: {
      indeed_apply: generalTabJobData?.options?.indeed_apply ? '1' : '0',
      indeed_salary: generalTabJobData?.options?.indeed_salary ? '1' : '0',
      sponsor_on_indeed: generalTabJobData?.options?.sponsor_on_indeed ? '1' : '0',
      blind_rating: generalTabJobData?.options?.blind_rating ? '1' : '0',
      hide_rating_activity: generalTabJobData?.options?.hide_rating_activity ? '1' : '0',
      auto_ratings: generalTabJobData?.options?.auto_ratings ? '1' : '0',
      title_field: generalTabJobData?.options?.title_field ? '1' : '0',
      gender_field: generalTabJobData?.options?.gender_field ? '1' : '0',
      employee_id_field: generalTabJobData?.options?.employee_id_field ? '1' : '0',
      linkedin_field: generalTabJobData?.options?.linkedin_field ? '1' : '0',
      privacy_acknowledgement: generalTabJobData?.privacy_acknowledgement ? '1' : '0',
      attachments: attachmentObject || {},
      job_expiry_email_reminder: generalTabJobData?.options?.job_expiry_email_reminder ? '1' : '0'
    },
    external: generalTabJobData?.external ? '1' : '0',
    linkedin_listing_opt_in: generalTabJobData?.linkedin_listing_opt_in ? '1' : '0',
    internal: generalTabJobData?.internal ? '1' : '0',
    recruitment_ad_user_id: generalTabJobData?.rm_team_member?.value
      ? generalTabJobData?.rm_team_member?.value.split(' -')[0]
      : null,
    summary: descriptionTabJobData?.summary?.value,
    description: descriptionTabJobData?.description?.value,
    template_enabled: templateTabJobData?.template_enabled,
    template: templateTabJobData?.template?.value,
    classification_ids: generalTabJobData?.classification_ids
      ? generalTabJobData?.classification_ids
      : [],
    application_recipient_ids: generalTabJobData?.application_recipient?.value
      ? generalTabJobData?.application_recipient?.value?.length > 0
        ? generalTabJobData?.application_recipient?.value?.map((x) => x.id)
        : []
      : [],
    revolve_position_title: revolveTabJobData?.revolve_position_title?.value,
    google_conversion_script: googleScriptTabJobData?.google_conversion_script?.value,
    panel_chair_ids: panelWorkflowTabJobData?.panel_chairs?.value
      ? panelWorkflowTabJobData?.panel_chairs?.value?.length > 0
        ? panelWorkflowTabJobData?.panel_chairs?.value?.map((x) => x.id)
        : []
      : [],
    panel_member_ids: panelWorkflowTabJobData?.panel_members?.value
      ? panelWorkflowTabJobData?.panel_members?.value?.length > 0
        ? panelWorkflowTabJobData?.panel_members?.value?.map((x) => x.id)
        : []
      : [],
    panel_observer_ids: panelWorkflowTabJobData?.panel_observers?.value
      ? panelWorkflowTabJobData?.panel_observers?.value?.length > 0
        ? panelWorkflowTabJobData?.panel_observers?.value?.map((x) => x.id)
        : []
      : [],
    source_ids: sourceListIds ? sourceListIds : [],
    auto_tags: autoTagsTabJobData?.auto_tags?.value
      ? autoTagsTabJobData?.auto_tags?.value?.length > 0
        ? autoTagsTabJobData?.auto_tags?.value?.map((x) => x.id)
        : []
      : []
  };
};

type Permissions = {
  [key: string]: boolean;
};

type TUserPermission = {
  paid_user: boolean;
  'Accounts - User': Permissions;
  'AI Features': Permissions;
  'App Menu': Permissions;
  Applications: Permissions;
  'Approval Forms': Permissions;
  Candidates: Permissions;
  Entities: Permissions;
  Events: Permissions;
  Forms: Permissions;
  'Full Search': Permissions;
  Integrations: Permissions;
  'Job Options': Permissions;
  Jobs: Permissions;
  Misc: Permissions;
  Reports: Permissions;
  Trash: Permissions;
  user_type: string;
};

export const editJobsConfig = (userPermissions: TUserPermission, jobFeedActive: boolean | null) => {
  const additionalOptions = [
    {
      id: 'blind_rating',
      name: 'Blind ratings'
    }
  ];

  jobFeedActive &&
    additionalOptions.unshift({
      id: 'sponsor_on_indeed',
      name: 'Sponsor on Indeed (Must have city and state filled)'
    });

  userPermissions?.['Job Options']?.['Indeed Apply Option'] &&
    additionalOptions.unshift({
      id: 'indeed_apply',
      name: 'Use Indeed Apply'
    });
  userPermissions?.['Integrations']?.['Indeed Integration'] &&
    additionalOptions.unshift({
      id: 'indeed_salary',
      name: 'Send salary to Indeed'
    });
  userPermissions?.['Integrations']?.['LinkedIn'] &&
    additionalOptions.push({
      id: 'linkedin_listing_opt_in',
      name: 'Post to Linkedin'
    });
  userPermissions?.['Job Options']?.['Linkedin'] &&
    additionalOptions.push({
      id: 'linkedin_field',
      name: 'Show Linkedin'
    });
  userPermissions?.['Job Options']?.['Candidate Title'] &&
    additionalOptions.push({
      id: 'title_field',
      name: 'Show title field'
    });
  userPermissions?.['Job Options']?.['Candidate Employee ID'] &&
    additionalOptions.push({
      id: 'employee_id_field',
      name: 'Show employee ID field'
    });
  userPermissions?.['Job Options']?.['Candidate Gender'] &&
    additionalOptions.push({
      id: 'gender_field',
      name: 'Show gender field'
    });
  userPermissions?.['Job Options']?.['Auto Rating'] &&
    additionalOptions.push({
      id: 'auto_ratings',
      name: 'Auto ratings'
    });
  userPermissions?.['Job Options']?.['Hide Rating Activity'] &&
    additionalOptions.push({
      id: 'hide_rating_activity',
      name: 'Hide ratings activities'
    });
  userPermissions?.['Job Options']?.['Send Job Expiry Reminder Email'] &&
    additionalOptions.push({
      id: 'job_expiry_email_reminder',
      name: 'Send Job Expiry Reminder Email'
    });

  return additionalOptions;
};

const localDefaults = (job: IJob) => {
  const data = [
    {
      value: 'en-au',
      label: 'English/Australia'
    },
    {
      value: 'en-ca',
      label: 'English/Canada'
    },
    {
      value: 'en-nz',
      label: 'English/New Zealand'
    },
    {
      value: 'en-sg',
      label: 'English/Singapore'
    },
    {
      value: 'en-uk',
      label: 'English/United Kingdom'
    },
    {
      value: 'en-us',
      label: 'English/United States'
    },
    {
      value: 'en-za',
      label: 'English/South Africa'
    },
    {
      value: 'fr-ca',
      label: 'French/Canada'
    }
  ];
  const i = data?.findIndex((x) => job?.locale === x?.value);
  if (i >= 0) return { label: data[i]?.label, value: data[i]?.value };
  else return null;
};

const setClassificationIds = (job: IJob) => {
  return job?.classifications?.filter((child) => child?.parent).map((sub) => sub?.id);
};
export const emojiRegex =
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
